import { useState } from 'react';
import { useAuth } from "../../context/auth";
import BypassModal from "./BypassModal";
const BalanceModal = ({ blockRequest = false, updateBypassCode = () => { } }) => {
    const [isOpen, setIsOpen] = useState(true);
    const { user } = useAuth();
    if (user.balance <= 0 || !isOpen)
        return null;
    const balanceContent = (
        <>
            Your current balance is
            <br />
            <text className="text-2xl md:text-4xl">
                {new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                })
                    .format(user.balance)}
            </text>
        </>
    );
    const actions = [{
        text: "Remind Me Later",
        onClick: () => setIsOpen(false), className: "text-md md:text-lg border-4 border-gray-400 text-gray-700 px-6 py-4 transition duration-300 hover:text-white hover:bg-gray-400/80",
        show: !blockRequest
    }, {
        text: "Pay Now",
        href: "https://dependable.managebuilding.com/Resident/portal/login", className: `text-md md:text-lg border-4 border-dependable-green px-6 py-4 transition duration-300 inline-block hover:bg-dependable-green/80 hover:text-white ${blockRequest ? 'mx-auto w-3/4' : ''}`,
        show: true
    }, {
        text: "Just paid?",
        onClick: () => window.location.reload(), className: "text-dependable text-sm hover:underline text-left block pl-10",
        show: blockRequest
    }];
    return (<BypassModal title="Outstanding Balance" content={balanceContent} showVerifyCode={blockRequest} onVerify={updateBypassCode} actions={actions} isOpen={isOpen} onClose={() => setIsOpen(false)} />);
};
export default BalanceModal;
